var p = function p(term, is_plural) {
  var _term;
  if (term === void 0 || term === null || term.trim().length <= 0) {
    return "";
  }
  if (((_term = term[term.length - 1]) === null || _term === void 0 ? void 0 : _term.toUpperCase()) === 'Y') {
    var _term$substring;
    // change y into ie
    term = (_term$substring = term.substring(0, term.length - 1)) === null || _term$substring === void 0 ? void 0 : _term$substring.concat('ie');
  }
  return "".concat(term).concat(is_plural === void 0 || !is_plural ? '' : 's');
};
export var msgs = {
  api_error: 'Could not complete request right now. Please try again later.',
  usernm: 'Username',
  orgnm: 'Organization Name',
  emailad: 'Email Address',
  req_for_invite: 'Request for Invite',
  admin: 'Admin',
  home: 'Home',
  "new": function _new(o) {
    return "New".concat(o ? " ".concat(o) : "");
  },
  settings: 'Settings',
  password: "Password",
  profile: "Profile",
  user: "User",
  address: 'Address',
  image: 'Image',
  view: "View",
  del: function del(o) {
    return "Delete: ".concat(o);
  },
  edit: function edit(o) {
    return "Edit ".concat(o);
  },
  add: function add(o) {
    return "Add ".concat(o);
  },
  update: function update(o) {
    return "Update ".concat(o);
  },
  change: function change(o) {
    return "Change ".concat(o);
  },
  remove: function remove(o) {
    return "Remove ".concat(o);
  },
  confirm: function confirm(o) {
    return "Confirm ".concat(o);
  },
  del_confirm: 'Are you sure you want to delete this record?',
  del_this: function del_this(obj) {
    return "Are you sure you want to delete this ".concat(obj, "?");
  },
  del_o: function del_o(o, nm) {
    return "Are you sure you want to delete the ".concat(o, " ").concat(nm, "?");
  },
  many: function many(term) {
    return p(term, true);
  }
};